module.exports = __webpack_public_path__ + "static/media/high-school-tutoring.8eae006d.jpg";